
import state from './moduleSDStatusManagementState'
import mutations from './moduleSDStatusManagementMutations'
import actions from './moduleSDStatusManagementActions'
import getters from './moduleSDStatusManagementGetters'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

